import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { confirmEmailChange, formatApiErrorDetail } from "../lib/api";
import { Reveal } from "../components/Motion";

export default function ConfirmEmailChange() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("confirming");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    document.title = "Confirm Email Change — Motion & Meaning";
    if (!token) { setState("invalid"); return; }
    if (ran.current) return;
    ran.current = true;
    confirmEmailChange({ token })
      .then((r) => { setEmail(r.email); setState("done"); })
      .catch((e) => { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); setState("error"); });
  }, [token]);

  return (
    <section className="relative min-h-screen flex items-center" data-testid="confirm-email-change-page">
      <div className="mm-vignette" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 w-full pt-32 pb-24">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.4em] text-gold mb-6">SIGN-IN EMAIL CHANGE</p>
          {state === "confirming" && <h1 className="font-serif text-5xl font-light text-white">Confirming…</h1>}
          {state === "done" && (
            <div data-testid="email-change-success">
              <h1 className="font-serif text-5xl md:text-6xl font-light text-white">Email<br />updated.</h1>
              <p className="text-white/60 mt-8 max-w-md">
                Your sign-in email is now <span className="text-gold break-words">{email}</span>. Use it the next time you sign in.
                A security notice was sent to your previous address.
              </p>
              <Link to="/login" className="inline-block mt-10 bg-gold text-black font-mono text-[11px] tracking-[0.25em] px-10 py-4 hover:bg-white transition-colors">SIGN IN</Link>
            </div>
          )}
          {(state === "error" || state === "invalid") && (
            <div data-testid="email-change-error">
              <h1 className="font-serif text-5xl font-light text-white">Invalid link.</h1>
              <p className="text-white/60 mt-8 max-w-md">{error || "This confirmation link is missing or malformed."}</p>
              <Link to="/account" className="inline-block mt-10 font-mono text-[11px] tracking-[0.25em] text-gold hover:text-white">GO TO MY ACCOUNT →</Link>
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
